import { useContext, useEffect } from 'react'
import { useQueryParams } from 'react-angle-dashboard-components'
import { Paths } from '../../../routes/paths'
import { BusinessOnboardingContext } from '../context/BusinessOnboardingContext'
import { useQuery } from 'react-query'
import { docusignService } from '../../../services'

const useOnboardingDocusignComplete = () => {
  const { modifyGroup } = useContext(BusinessOnboardingContext)

  const query = useQueryParams()

  const docusignEvent = query.get('event')
  const signingComplete = docusignEvent === 'signing_complete'

  // complete onboarding when docusign is completed and redirect to onboarding completed page
  useEffect(() => {
    const handleContinue = async () => {
      await modifyGroup.mutateAsync({
        onboarding_status: 'under_review'
      })
      window.location.assign(
        window.location.origin + Paths.newBusinessOnboardingComplete
      )
    }

    if (signingComplete) {
      handleContinue()
    }
  }, [signingComplete, modifyGroup])

  const { data, isError, isLoading } = useQuery(
    'getDocusign',
    () =>
      docusignService.getDocusignSigningUrl(
        `${window.location.origin}/business/onboarding/statement`
      ),
    {
      initialData: {},
      refetchOnWindowFocus: false,
      retry: 1,
      enabled: !signingComplete
    }
  )

  return {
    signingComplete,
    data,
    isError,
    isLoading
  }
}

export default useOnboardingDocusignComplete
